import lodash from 'lodash'
import { FC, useEffect, useMemo } from 'react'
import { SelectInput } from 'react-admin'
import { useForm, useFormState } from 'react-final-form'

interface PropTypes {
  source: string
  fieldId: string
}

const CONDITIONAL_CHOICES = [
  { id: 'include', name: 'Include' },
  { id: 'exclude', name: 'Exclude' },
]

const STATUS_CHOICES = [
  { id: 'ordered', name: 'Ordered' },
  { id: 'partially_ordered', name: 'Partially Ordered' },
  { id: 'failed', name: 'Failed' },
]

const StatusFilter: FC<PropTypes> = ({ source }) => {
  const form = useForm()
  const formValues = useFormState().values
  const value = useMemo(() => lodash.get(formValues, `${source}.fields`), [formValues, source])

  useEffect(() => {
    let newValue = {}
    if (value?.conditional !== undefined && value?.status) {
      if (value.conditional === 'include') {
        newValue['include_order_status'] = value.status
      } else if (value.conditional === 'exclude') {
        newValue['exclude_order_status'] = value.status
      }
    }
    form.change(`${source}.value`, newValue)
  }, [value, source, form])

  return (
    <>
      <SelectInput
        choices={CONDITIONAL_CHOICES}
        label={false}
        source={`${source}.fields.conditional`}
        variant="outlined"
        margin={'none'}
        style={{ minWidth: '100px' }}
      />
      <SelectInput
        choices={STATUS_CHOICES}
        label={false}
        source={`${source}.fields.status`}
        variant="outlined"
        margin={'none'}
        style={{ minWidth: '140px' }}
      />
    </>
  )
}

export default StatusFilter
